import {User} from "@/types";
import {Link} from "@inertiajs/react";
import React from "react";
import useTranslations from '@/hooks/useTranslations';

export default function ApiOverview({user}: { user?: User }) {
    const { __ } = useTranslations();
    return (
        <div
            className=" container mx-3 lg:mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row lg:space-x-10 mt-5 lg:mt-0  justify-center items-center ">
            <div className="lg:w-1/2 mt-5 lg:mt-0">
                <h1 className="text-3xl mb-10 text-gray-900 dark:text-gray-100">
                    {__('api-info.overview.title')}
                </h1>
                <p className="lg:mr-0 text-gray-700 dark:text-gray-300">
                    {__('api-info.overview.description')}
                </p>
                {
                    user && (
                        <Link
                            href={route('api-keys.index')}
                            className={`text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 me-2  duration-150 mt-10 w-fit inline-block`}
                        >
                            {__('api-info.overview.create_api_key')}
                        </Link>
                    )
                }
                {
                    !user && (
                        <Link
                            href={route('register')}
                            className={`text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 me-2  duration-150 mt-10 w-fit inline-block`}
                        >
                            {__('api-info.overview.get_started')}
                        </Link>
                    )
                }


            </div>
            <div className="lg:w-1/2  lg:px-20 mr-10  mt-10 lg:mt-0">
                <img className="shadow-lg shadow-gray-400 dark:shadow-none dark:border dark:border-gray-700 rounded-lg" alt={__('api-info.overview.image_alt')}
                     src="/img/api_code.png"/>
            </div>
        </div>
    )
}
